"use client";

import React from "react";
import BrandsSliderSection from "../components/BrandsSliderSection";
import HeroSection from "../components/HeroSection";
import ServicesCardSection from "../sections/website-develoopment/WebsiteDevelopmentServicesCardSection";
import ProjectsShowcase from "../components/ProjectsShowcase";
import TechStackTabs from "../components/TechStackTabs";
import WhyChoose from "../components/WhyChoose";
import ExtraSectionsDispatcher from "../components/ExtraSectionsDispatcher";
import { useServiceData } from "../hooks/useServiceData";

export default function WebsiteDevelopmentClient() {
  const { data } = useServiceData();

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: data?.metaTitle || "Website Development Services",
    serviceType: "Website Development",
    provider: { "@type": "Organization", name: "CodeQlik" },
    areaServed: "Global",
    description: data?.metaDescription || "Fast, responsive, and SEO‑optimized websites. Custom design, performance tuning, integrations, secure builds, and ongoing maintenance.",
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      {/* Hero section */}
      <HeroSection dynamicData={data?.hero} />
      {/* Brands slider */}
      <BrandsSliderSection dynamicData={data?.brands} />
      {/* Service cards */}
      <ServicesCardSection dynamicData={data?.services} />
      
      {/* Render all extra sections from backend */}
      <ExtraSectionsDispatcher />

      {/* Projects section */}
      <ProjectsShowcase dynamicData={data?.portfolio} />
      {/* TechStackTabs section */}
      <TechStackTabs dynamicData={data?.technologies} />
      {/* WhyChoose Section */}
      <WhyChoose dynamicData={data?.features} />
    </>
  );
}
